import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';
import {
    MonitorPlay,
    Building,
    Wrench,
    Rocket,
    Stars,
    Briefcase,
    GraduationCap,
    ChevronRight, BookOpen,
    Award, Users, Globe,
    Clock, Bookmark, Share2, ArrowUpRight,
    Target, // for Vision
    Flag, // for Mission
    HelpCircle, // for Why Study
    Award as UniqueIcon // for What Makes Unique

} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../components/TitleComponent';

const DiplomaPrograms = [
    {
        name: "Diploma in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    },
    {
        name: "Diploma in Computer Science & Engineering",
        path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    },
    {
        name: "Diploma in Electronics and Communication Engineering",
        path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    },
    {
        name: "Diploma in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/ai-ml"
    },

]

const undergraduatePrograms = [

    {
        name: "Bachelor of Technology in Cloud Computing and Engineering",
        path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    },
    {
        name: "Bachelor of Technology in Data Science and Engineering",
        path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    },
    {
        name: "Bachelor of Technology in Cyber Security and Engineering",
        path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    },
    {
        name: "Bachelor of Technology in Artificial Intelligence Machine Learning and Engineering",
        path: "/programmes/ug-courses/engineering/btech/ai-ml"
    },
    {
        name: "Bachelor of Technology in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/civil-engineering"
    },
    {
        name: "Bachelor of Technology in Computer Science and Engineering",
        path: "/programmes/ug-courses/engineering/btech/computer-science-engineering"
    },
    {
        name: "Bachelor of Technology in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/mechanical-engineering"
    },
    // {
    //     name: "Bachelor of Technology in Mechatronics and Robotics",
    //     path: "/programmes/ug-courses/engineering/btech/mechatronics-and-robotics"
    // },
]

const PostgraduatePrograms = [
    {
        name: "Master of Technology in Thermal Engineering",
        path: "/programmes/pg-courses/engineering/mtech/thermal-engineering"
    },
    {
        name: "Master of Technology in Production Engineering",
        path: "/programmes/pg-courses/engineering/mtech/production-engineering"
    },
    {
        name: "Master of Technology in Renewable Energy",
        path: "/programmes/pg-courses/engineering/mtech/renewable-energy"
    },
    // {
    //     name: "Master of Technology in Electric Vehicle  Technology",
    //     path: "/programmes/pg-courses/engineering/mtech/electric-vehicle"
    // },
    {
        name: "Master of Technology in Structural Engineering",
        path: "/programmes/pg-courses/engineering/mtech/structural-engineering"
    },
    {
        name: "Master of Technology in Transportation Engineering",
        path: "/programmes/pg-courses/engineering/mtech/transportation-engineering"
    },
    // {
    //     name: "Master of Technology in Data Science and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/data-science-engineering"
    // },
    // {
    //     name: "Master of Technology in Artificial Intelligence Machine Learning and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/ai-ml"
    // },
    {
        name: "Master of Technology in Digital Communication Engineering",
        path: "/programmes/pg-courses/engineering/mtech/digital-communication"
    },

]



const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "5000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "95%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "100+", label: "Industry Partners", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Welcome to the School of Journalism and Mass Communication – Maya Devi University</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>At Maya Devi University, one of the Best Journalism Colleges in Dehradun, we offer innovative and industry-oriented programs in Journalism and Mass Communication. Our School of Journalism and Mass Communication prepares students to become leaders in the ever-evolving media landscape. Our courses are designed to provide you with a comprehensive understanding of the media industry, from traditional journalism to digital media, with excellent placement opportunities in top media houses.
            </p>
        </div>
    </motion.div>
);

const VisionMissionSection = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Bachelor of Journalism and Mass Communication (BJMC)</h4>
            </div>
            <div className='mb-4'>
                <p>Duration: 3 Years <br/>
                    The Bachelor of Journalism and Mass Communication (BJMC) program at Maya Devi University is designed to provide a strong foundation in media, journalism, and communication. The program covers a wide range of subjects such as news reporting, media law, broadcast journalism, advertising, and public relations, along with practical skills such as content creation, editing, and media management. Students will develop an understanding of how media shapes public opinion, and learn how to produce and present information across various platforms including print, digital, and broadcast media.
                    <br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Data Science – Master data analytics, machine learning, and AI-driven decision-making.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Cyber Security – Gain expertise in ethical hacking, digital forensics, and network security.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>AI & Machine Learning (AIML) – Learn AI technologies, deep learning, and automation solutions.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Full Stack Development – Become a proficient developer with expertise in front-end and back-end technologies.</span>
                </li>
            </ul> */}
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Master of Journalism and Mass Communication (MJMC)</h4>
            </div>
            <div className='mb-4'>
                <p>Duration: 2 Years<br/>
                    The Master of Journalism and Mass Communication (MJMC) program is designed for students who wish to gain advanced knowledge in media studies and specialize in various areas of journalism. The MJMC program focuses on in-depth media research, investigative journalism, media management, and content creation. Students will acquire higher-level skills to critically analyze the role of media in modern society and prepare for leadership roles in the media industry.
                    <br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Curriculum: Students learn about diagnostic imaging techniques, radiation safety, medical terminology, and patient care. The program also includes practical training in radiology labs.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Skills Developed: Students gain proficiency in operating imaging equipment, performing diagnostic tests, and ensuring patient safety during imaging procedures.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: Graduates can pursue careers as radiology technicians, imaging specialists, or radiology consultants in hospitals, diagnostic centers, and imaging clinics.</span>
                </li>
            </ul> */}
        </motion.div>

        {/* <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Diploma in Nursing Assistant</h4>
            </div>
            <div className='mb-4'>
                <p>A one-year program designed for individuals seeking a quick pathway into the healthcare field. This course equips students with foundational knowledge and hands-on skills required for assisting in patient care under the supervision of qualified nurses and doctors.<br />
                </p>
            </div>
            <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Curriculum: The program covers subjects like clinical biochemistry, microbiology, hematology, and pathology. Students will also gain experience in lab procedures, test analysis, and quality control.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Skills Developed: Graduates are equipped with technical skills to perform lab tests, analyze results, and provide accurate data to healthcare providers for diagnosis and treatment.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: BMLT graduates are in high demand in hospitals, diagnostic laboratories, research centers, and healthcare facilities. They can work as medical lab technicians, lab supervisors, or quality control analysts.</span>
                </li>
            </ul>
        </motion.div> */}

        {/* <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Master of Computer Application (MCA) with Specialization in:</h4>

            </div>
            <div className='mb-4'>
                <p>
                    The B.Sc. in Operation Theater Technician is a 3-year program designed to train students in the technical aspects of operating rooms. Operation theater technicians are essential for ensuring the smooth functioning of surgical procedures, providing technical support, and managing medical equipment.<br />
                </p>
            </div>
            <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Data Science – Advance your career with expertise in AI, Big Data, and predictive analytics.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Full Stack Development – Become an industry-ready software professional with advanced development skills.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: Graduates can work as operation theater technicians, surgical assistants, or sterile supply coordinators in hospitals, surgical centers, and trauma care units.</span>
                </li>
            </ul>
        </motion.div> */}
    </div>
);


const ProgramSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Our Programs</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>. Our School of Journalism and Mass Communication prepares students to become leaders in the ever-evolving media landscape. Our courses are designed to provide you with a comprehensive understanding of the media industry, from traditional journalism to digital media, with excellent placement opportunities in top media houses.
            </p>

            {/* <p>The 21st century is marked by rapid innovation, and exposure to engineering allows students to stay at the forefront of modern technological trends. Engineering plays a vital role in solving real-world problems, offering practical solutions that address the needs of society. As long as humanity continues to evolve, the demand for skilled engineers remains essential.  </p>

            <p>Upon graduation, engineers have access to a broad spectrum of career opportunities, whether in traditional engineering roles or in entrepreneurial ventures, enabling them to innovate and contribute to society in multiple  ways.
            </p> */}
        </div>
    </motion.div>
);

const WhySection = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Why Choose Journalism and Mass Communication as a Career?</h4>
        </div>
        {/* <div className='mb-4'>
            <p> <div className='mb-4'>
                <p>The healthcare industry is rapidly expanding, making nursing one of the most rewarding and stable career choices. Nurses play a pivotal role in patient care, medical research, and community health development. Whether you aspire to work in a high-tech hospital, serve in rural healthcare, or pursue advanced specializations, nursing offers endless opportunities for growth and fulfillment.<br />
                </p>
            </div><br />
            </p>
        </div> */}
        <ul className="space-y-3 text-gray-700">
            {/* <span><b>Career Opportunities After Completing a Nursing Program:</b></span><br /> */}
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Top-Ranked Journalism College in Dehradun: As one of the Best Journalism Colleges in Dehradun, we offer an industry-centric curriculum designed by experienced professionals.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>State-of-the-Art Infrastructure: Students have access to modern media labs, editing suites, and broadcast studios, ensuring practical training with the latest tools and technology.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Experienced Faculty: Our faculty members are seasoned professionals from the media industry who bring their expertise to the classroom, ensuring that students receive real-world insights and guidance.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>100% Placement Assistance: Maya Devi University has strong ties with top media houses, digital platforms, PR agencies, and advertising firms. We provide 100% placement assistance, ensuring that our graduates secure internships and jobs in leading organizations.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Practical Exposure: Students engage in live projects, internships, and media productions to gain hands-on experience and build portfolios that showcase their skills.</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Nursing Assistant</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        {/* <div className='mb-4 mt-4'>
            <p> <div className='mb-4'>
                <p>Embark on a journey to make a meaningful difference in people’s lives with a nursing degree or diploma from Maya Devi University, proudly known as one of the best nursing colleges in Dehradun.<br />
                </p>
            </div><br />
            </p>
        </div> */}
    </motion.div>
);


const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? '2 Years' : '4 Years'}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? 'PG' : 'UG'}</span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-5xl"
        >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
                School of Journalism and Mass Communication – Maya Devi University
            </h1>
            <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
                At Maya Devi University, one of the Best Journalism Colleges in Dehradun, we offer innovative and industry-oriented programs in Journalism and Mass Communication. Our School of Journalism and Mass Communication prepares students to become leaders in the ever-evolving media landscape. Our courses are designed to provide you with a comprehensive understanding of the media industry, from traditional journalism to digital media, with excellent placement opportunities in top media houses.
            </p>
            <Link to="https://admission.maya.edu.in/">
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
                >
                    Apply Now
                    <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
                </motion.button>
            </Link>
        </motion.div>
    </div>
);

const Placement = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Placement Opportunities</h4>
        </div>
        <div className='mb-4'>
            <p> <div className=''>
            The School of Journalism and Mass Communication at Maya Devi University has an excellent track record of placing students in top-tier media organizations, both nationally and internationally. Our graduates have found successful roles in:<br />

            </div><br />
            </p>
        </div>
        <ul className="space-y-3 text-gray-700">
            {/* <span><b>Career Opportunities After Completing a Nursing Program:</b></span><br /> */}
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Television Channels (News, Entertainment, Sports)</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Newspapers & Magazines</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Advertising & PR Agencies</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Social Media & Digital Marketing Firms</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Broadcasting Networks</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Content Production Companies</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Online News Portals</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        <ul className="space-y-3 text-gray-700 mt-4">
            <span><b>Some of the top companies where our students have been placed include:</b></span><br />
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>The Times of India</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>NDTV</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Zee News</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>India Today</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>BBC News</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Ogilvy & Mather (Advertising)</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Rediffusion (PR)</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        {/* <div className='mb-4 mt-4'>
            <p> <div className='mb-4'>
                <p>If you're looking for the best education in Hospital Administration and Public Health, Maya Devi University is the right choice for you. Explore our courses today and take the first step towards a rewarding career in healthcare management and public health.<br />
                </p>
            </div><br />
            </p>
        </div> */}
    </motion.div>
);

const JournalismAndMassCommunication = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
             <Title canonicalPath="/programmes/School-Of-Journalism-and-Mass-Communication" />
             <Title title="Best Journalism and Mass Communication  College in Dehradun, Uttarakhand" description=" Maya Devi University is one of the best Journalism and Mass Communication  University in Dehradun, offering world-class Journalism and Mass Communication programs in different Branches." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                <WhySection />
                <ProgramSection />
                {/* <WhatSection /> */}
                <VisionMissionSection />
                <Placement />
                <div className="space-y-6 md:space-y-8">
                    {/* <Department
                        title="Diploma Programs"
                        icon={<MonitorPlay className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={DiplomaPrograms}
                    /> */}
                    {/* <Department
                        title="Undergraduate Programs"
                        icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={undergraduatePrograms}
                    />
                    <Department
                        title="Postgraduate Programs"
                        icon={<Wrench className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={PostgraduatePrograms}
                    /> */}
                </div>

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Industry-Relevant Curriculum designed by Core Academia & Renowned Industry Experts",
                            "Renowned Domain Specific & Highly Rich Experienced Faculty",
                            "State-of-the-art infrastructure including computer labs",
                            "Centre of Excellence in Specific Domain & Technology",
                            "Continuous learning and skill enhancement",
                            "Hands-On Learning through practical projects",
                            "Live Industry Projects based Learning",
                            "Global Recognition and accreditation",
                            "LMS based Pedagogy",
                            "Choice Based Credit System (CBCS)",
                            "Industry Collaborations and Internships",
                            "Full-Time Industrial Internship",
                            "Entrepreneurship programs and incubation centres"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Cloud Computing Specialist",
                            "Data Scientist/Data Analyst",
                            "AI/ML Engineer",
                            "Cybersecurity Analyst",
                            "Software Developer",
                            "Database Administrator",
                            "Network Engineer",
                            "IT Consultant",
                            "Systems Analyst",
                            "Web Developer",
                            "Software Engineer"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default JournalismAndMassCommunication;